import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categoryName } from '@/components/base/ArticleCard';

export default function EditorPicks() {
  const picks = articles.filter((a) => a.featured).slice(1, 3);
  const main = articles[6];

  return (
    <section id="picks" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
            <i className="ri-bookmark-3-line" aria-hidden="true"></i>
            EDITOR&apos;S PICKS
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">编辑精选专题</h2>
          <p className="mt-3 text-sm text-foreground-600">本周编辑组反复回看的三篇，甜度稳定，适合收藏。</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <article className="lg:col-span-5 flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-accent-50">
          <div className="w-full h-52 md:h-64 overflow-hidden bg-background-200">
            <img
              src={main.cover}
              alt={main.title}
              title={`${main.title} - 糖心吃瓜`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex flex-1 flex-col p-5 md:p-7">
            <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-200 px-3 py-1 text-xs text-accent-900">
              <i className="ri-star-smile-line" aria-hidden="true"></i>
              本周主打
            </span>
            <h3 className="mt-4 font-heading text-xl md:text-2xl text-foreground-950 leading-snug">
              <Link to={`/article/${main.slug}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                {main.title}
              </Link>
            </h3>
            <p className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">{main.excerpt}</p>
            <div className="mt-5 flex items-center gap-4 text-xs text-foreground-500">
              <span className="rounded-full bg-background-50 px-2.5 py-0.5">{categoryName(main.category)}</span>
              <span>{main.readTime}</span>
            </div>
          </div>
        </article>

        <div className="lg:col-span-7 flex flex-col gap-5">
          {picks.map((a, i) => (
            <article
              key={a.id}
              className={`flex flex-col sm:flex-row overflow-hidden rounded-2xl border border-background-200 ${
                i === 0 ? 'bg-background-50' : 'bg-secondary-50'
              }`}
            >
              <div className="w-full sm:w-56 h-44 sm:h-auto shrink-0 overflow-hidden bg-background-200">
                <img
                  src={a.cover}
                  alt={a.title}
                  title={`${a.title} - 糖心吃瓜`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col justify-center p-5 md:p-6">
                <span className="text-xs text-primary-600">{categoryName(a.category)}</span>
                <h3 className="mt-2 text-base md:text-lg font-medium text-foreground-950 leading-snug">
                  <Link to={`/article/${a.slug}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                    {a.title}
                  </Link>
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{a.excerpt}</p>
                <Link
                  to={`/article/${a.slug}`}
                  className="mt-4 inline-flex w-fit items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  阅读全文
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </article>
          ))}

          <div className="rounded-2xl border border-background-200 bg-secondary-950 p-6 md:p-7">
            <p className="font-heading text-lg md:text-xl text-secondary-50 leading-relaxed">
              “磕瓜不该是消耗，而是一天里最轻的那几分钟。”
            </p>
            <p className="mt-3 text-xs text-secondary-400">—— 糖心吃瓜编辑组 · 内容原则</p>
          </div>
        </div>
      </div>
    </section>
  );
}